export { ParaglideMessage } from "./message.js";
export type {
	MessageMarkupAttributes,
	MessageMarkupAttribute,
	MessageMarkupOptions,
	MessageMarkupOption,
	MessagePart,
} from "@inlang/paraglide-js";
export type {
	MarkupRenderer,
	MarkupRendererProps,
	MessageLike,
	MessageOptions,
	MessageProps,
} from "./message.js";
